export default "/images/right-arrow-icon.png?0aae1208e932b3047eb041c163b2f4d3";